import './index.scss';
import { useContext } from 'react';
import utility from 'src/utils/utility';
import UserContext from 'src/provider/state-manager/userProvider';
import { UploadResults } from 'src/component/UploadResults';

const UploadResultsDashboard = () => {
    const { user } = useContext(UserContext)

    return (
        <div className='dashboard-upload-results'>
            <UploadResults user={user} />
        </div>
    )
}

export default utility.routeData('upload-results', 'Upload Results', <UploadResultsDashboard />)
